import { linkToSignOut } from "$routes/_lib/links";
import { Box, styled } from "@material-ui/core";
import { Link, Outlet } from "react-router-dom";
import { EpocusHeader } from "../_lib/epocus-header";
import {
  EPOCUS_BG,
  EPOCUS_BORDER,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../_lib/epocus-palette";
import { EpocusThemeProvider } from "../_lib/epocus-theme-provider";
import { useHasEpocusProgram } from "../_lib/use-has-epocus-program";
import { linkToEpocusHome } from "../links";

const Shell = styled(Box)({
  height: "100dvh",
  overflow: "hidden",
  backgroundColor: EPOCUS_BG,
  display: "flex",
  flexDirection: "column",
  "@supports not (height: 100dvh)": { height: "100vh" },
});

const SubBar = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 4,
  padding: "0 8px",
  backgroundColor: EPOCUS_WHITE,
  borderBottom: `1px solid ${EPOCUS_BORDER}`,
});

const SubBarLink = styled(Link)({
  display: "inline-flex",
  alignItems: "center",
  minHeight: 44,
  padding: "0 10px",
  fontSize: rem(13),
  fontWeight: 600,
  color: EPOCUS_TEXT_SECONDARY,
  textDecoration: "none",
  "&:hover": { color: EPOCUS_TEXT_PRIMARY },
});

const Frame = styled(Box)({
  flex: 1,
  minHeight: 0,
  width: "100%",
  maxWidth: 640,
  margin: "0 auto",
  padding: 12,
  display: "flex",
  flexDirection: "column",
});

export const EpocusOnboardingLayout: FCwC = ({ children = <Outlet /> }) => {
  const { hasProgram } = useHasEpocusProgram();

  return (
    <EpocusThemeProvider>
      <Shell>
        <EpocusHeader persistent />
        <SubBar>
          {hasProgram && (
            <SubBarLink to={linkToEpocusHome()}>Back to ePOCUS</SubBarLink>
          )}
          <SubBarLink to={linkToSignOut()}>Log out</SubBarLink>
        </SubBar>
        <Frame>{children}</Frame>
      </Shell>
    </EpocusThemeProvider>
  );
};
